<ng-container *ngIf="formGroup">
  <div [formGroup]="formGroup">

    <!-- DOCUMENT TYPE -->
    <div class="form-group">
      <label class="label_form">
        {{ (labelPrefix + '.document_type') | translate }}
      </label>

      <ng-select
        [items]="documentTypes"
        bindLabel="label"
        bindValue="value"
        [clearable]="false"
        class="custom_select custom_select_single w-100"
        [formControlName]="typeControlName"
        [placeholder]="(labelPrefix + '.document_type_input') | translate"
        [ngClass]="{
          'has-error':
            formGroup.get(typeControlName)?.invalid &&
            formGroup.get(typeControlName)?.touched
        }"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.label | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ item.label | translate }}
        </ng-template>
      </ng-select>
    </div>

    <!-- DOCUMENT NUMBER -->
    <div
      class="form-group"
      *ngIf="
        formGroup.get(typeControlName)?.value !== null &&
        formGroup.get(typeControlName)?.value !== docTypeEnum.WithoutDocument
      "
    >
      <label class="label_form">
        {{ (labelPrefix + '.document_number') | translate }}
      </label>
      <input
        class="input_form"
        [formControlName]="numberControlName"
        [placeholder]="(labelPrefix + '.document_number_placeholder') | translate"
        (input)="limitLength($event)"
        autocomplete="off"
      />
      <div
        *ngIf="
          (formGroup.get(numberControlName)?.hasError('pattern') ||
            formGroup.get(numberControlName)?.hasError('invalidNif') ||
            formGroup.get(numberControlName)?.hasError('invalidNie') ||
            formGroup.get(numberControlName)?.hasError('invalidRut') ||
            formGroup.get(numberControlName)?.hasError('invalidPassport')) &&
          formGroup.get(numberControlName)?.touched
        "
      >
        <span class="alert-text">
          {{ (labelPrefix + '.error_invalid_document') | translate }}
        </span>
      </div>
    </div>

  </div>
</ng-container>
